import { faUserDoctor } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, CircularProgress, Typography } from "@mui/material";
import { useState } from "react";
import { getBenef } from "../../../Store/storages/BeneficiarioStorage";
import { StepIngressarAtendProps } from "../../../interfaces/props/SaudeOnline/IngressarNoAtendimento/StepIngressarAtendProps";
import { ingressarReuniao } from "../../../services/IngressarAtendimentoService";
import HeaderTelessaude from "./HeaderTelessaude";
import ModalEncerrarAtendimento from "./ModalEncerrarAtendimento";
import { sxButtonTelessaudeAtendIngressar, sxTypographyTelessaudeSubtitle } from "./sxProps";

const StepRedirectZoom: React.FC<StepIngressarAtendProps> = ({ ...props }) => {

  const [showModalEncerrarAtendimento, setShowModalEncerrarAtendimento] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const { nextStep, idReuniao, idAgenda, setZoomUrl } = { ...props };

  const handleShowEncerrarAtendimento = () => {
    setShowModalEncerrarAtendimento(showModalEncerrarAtendimento => !showModalEncerrarAtendimento);
  }

  const handleClickIngressar = async () => {
    setLoading(true);
    const parametrosReuniao = await ingressarReuniao(idReuniao || '');

    if (parametrosReuniao) {
      const benef = getBenef();
      const nomeUsuario: string = benef ? benef.nome + ' ' + benef.sobrenome : 'Paciente';
      const meetingNo: string = parametrosReuniao.meetingNo;
      const pwd: string = parametrosReuniao.meetingPassword;
      const uname = encodeURIComponent(nomeUsuario);

      const zoomUrl = `https://unimedcampinas.zoom.us/wc/${meetingNo}/join?prefer=1&pwd=${pwd}&uname=${uname}`;

      setZoomUrl!(zoomUrl);
      window.open(zoomUrl, '_blank');

      setLoading(false);
      nextStep();
    }
  }

  return (
    <>
      <div className='ingressar-atendimento-gap-content'>
        <HeaderTelessaude />
        <Typography sx={sxTypographyTelessaudeSubtitle}>VAMOS COMEÇAR?</Typography>
        <div className='icon-circle-container-102px'>
          <div className='circle-background' />
          <FontAwesomeIcon icon={faUserDoctor} className='fa-doctor-ingressar-atendimento' />
        </div>
        <Button
          type='button'
          variant='contained'
          sx={sxButtonTelessaudeAtendIngressar}
          onClick={handleClickIngressar}
          disabled={loading}
        >
          {loading ? <CircularProgress color="inherit" /> : <Typography>Ingressar</Typography>}
        </Button>
      </div>
      <ModalEncerrarAtendimento
        handleShowModal={handleShowEncerrarAtendimento}
        showModal={showModalEncerrarAtendimento}
        idAgenda={idAgenda || ''}
      />
    </>
  )
}

export default StepRedirectZoom;